import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import masterService from "services/MasterService";

export const initialState = {
  loading: false,
  message: "",
  list: null
};

export const expenseListAll = createAsyncThunk("/expense/list", async (data, { rejectWithValue }) => {
    try {
      const response = await masterService.getExpense(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const expenseSlice = createSlice({
  name: "expense",
  initialState,
  reducers: {
    expenseList: (state, action) => {
      state.loading = true;
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(expenseListAll.pending, (state) => {
        state.loading = false;
      })
      .addCase(expenseListAll.fulfilled, (state, action) => {
        state.loading = true;
        state.list = action.payload;
      })
  },
});

export const { expenseList } = expenseSlice.actions;

export default expenseSlice.reducer;
